// extracted by mini-css-extract-plugin
export var about__btn = "style-module--about__btn--9b6fe";
export var advantages = "style-module--advantages--16661";
export var advantages__btn = "style-module--advantages__btn--81e67";
export var advantages__img = "style-module--advantages__img--d9021";
export var advantages__text = "style-module--advantages__text--95f61";
export var advantages__wrapper = "style-module--advantages__wrapper--ea06e";
export var founder = "style-module--founder--dd68a";
export var founder__title = "style-module--founder__title--1b0b9";
export var licenses = "style-module--licenses--66c28";
export var licenses__title = "style-module--licenses__title--7ef8b";
export var methodists = "style-module--methodists--17e48";
export var methodists__title = "style-module--methodists__title--7e30f";
export var methodists__undertext = "style-module--methodists__undertext--db941";